var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1498_25281)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M20.6211 9.04961C19.5711 4.42961 15.5411 2.34961 12.0011 2.34961C12.0011 2.34961 12.0011 2.34961 11.9911 2.34961C8.46107 2.34961 4.42107 4.41961 3.37107 9.03961C2.20107 14.1996 5.36107 18.5696 8.22107 21.3196C9.28107 22.3396 10.6411 22.8496 12.0011 22.8496C13.3611 22.8496 14.7211 22.3396 15.7711 21.3196C18.6311 18.5696 21.7911 14.2096 20.6211 9.04961Z",
    fill: "#58247E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.0016 14.0598C13.7413 14.0598 15.1516 12.6495 15.1516 10.9098C15.1516 9.17007 13.7413 7.75977 12.0016 7.75977C10.2619 7.75977 8.85156 9.17007 8.85156 10.9098C8.85156 12.6495 10.2619 14.0598 12.0016 14.0598Z",
    fill: "#58247E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1498_25281"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0 0.599609)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.4c5b9bd9a906e789521b509aa9718ec9.svg";
export { ForwardRef as ReactComponent };